import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import {
  LocalOffer as TagIcon,
} from '@mui/icons-material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function PopularTagsChart({ tagsStats, isLoading }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  // Préparer les données pour le graphique en barres verticales
  const chartData = tagsStats && tagsStats.length > 0
    ? tagsStats
        .map((tag) => ({
          name: tag.nom,
          value: tag.nombre_livres || 0,
          tagId: tag.id, // Ajouter l'ID pour la navigation
        }))
        .filter(item => item.value > 0)
        .slice(0, 10) // Limiter à 10 étiquettes
    : [];

  if (isLoading) {
    return (
      <Card sx={{ borderRadius: 2, boxShadow: 2, mb: 4 }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        </CardContent>
      </Card>
    );
  }

  const handleBarClick = (data, index) => {
    if (chartData[index] && chartData[index].tagId) {
      navigate(`/tags/${chartData[index].tagId}`);
    }
  };

  if (chartData.length === 0) {
    return (
      <Card sx={{ borderRadius: 2, boxShadow: 2, mb: 4 }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <TagIcon sx={{ fontSize: 24, color: '#ff9800', mr: 1 }} />
            <Typography variant="h6" component="h3" sx={{ fontWeight: 600 }}>
              {t('homePage.top10Tags')}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
            {t('homePage.noTagsFound')}
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ borderRadius: 2, boxShadow: 2, mb: 4 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <TagIcon sx={{ fontSize: 24, color: '#ff9800', mr: 1 }} />
          <Typography variant="h6" component="h3" sx={{ fontWeight: 600 }}>
            {t('homePage.top10Tags')}
          </Typography>
        </Box>
        <Box
          sx={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            '& svg': {
              userSelect: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
              msUserSelect: 'none',
            },
            '& *': {
              userSelect: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
              msUserSelect: 'none',
            },
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            return false;
          }}
          onSelectStart={(e) => {
            e.preventDefault();
            return false;
          }}
        >
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={chartData}
              margin={{ top: 5, right: 30, left: 20, bottom: 60 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="name" 
                angle={-45}
                textAnchor="end"
                height={80}
                tick={{ fontSize: 12 }}
              />
              <YAxis />
              <Tooltip />
              <Bar 
                dataKey="value" 
                fill="#ff9800" 
                radius={[8, 8, 0, 0]}
                onClick={handleBarClick}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill="#ff9800"
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
}

export default PopularTagsChart;

